module.exports = __webpack_public_path__ + "img/POP-00014-2.690eb705.png";